<template>
	<ul class="flex flex-wrap items-center gap-1.5">
		<template v-for="(item, index) in visible">
			<li :key="index" class="inline-flex max-w-full items-center gap-1.5 rounded-full bg-gray-50 px-2.5 py-1 text-xs text-gray-600 ring-1 ring-gray-200">
				<i class="text-gray-400" :class="icon(item.address_type)"></i>
				<span class="truncate">{{ label(item) }}</span>
			</li>
		</template>
		<!-- Restante !-->
		<template v-if="hidden > 0">
			<li>
				<button
					type="button"
					class="rounded-full px-2 py-1 text-xs font-semibold text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-turquoise focus:ring-offset-1"
					@click="expanded = true">
					+{{ hidden }}
				</button>
			</li>
		</template>
	</ul>
</template>

<script>
export default {
	name: "SupportTicketParticipants",
	props: {
		participants: {
			type: Array,
			default: () => []
		},
		/**
		 * Quantos chips aparecem antes de "+N"
		 */
		limit: {
			type: Number,
			default: 4
		}
	},
	data() {
		return {
			expanded: false
		}
	},
	computed: {
		visible() {
			return this.expanded ? this.participants : this.participants.slice(0, this.limit)
		},
		hidden() {
			return this.participants.length - this.visible.length
		}
	},
	methods: {
		/**
		 * Ícone por tipo de destinatário
		 * @param address_type
		 * @returns {string}
		 */
		icon(address_type) {
			return {
				user: "fal fa-user",
				company: "fa fa-building",
				partner: "fa fa-building",
				provider: "fal fa-truck",
				department: "fal fa-layer-group"
			}[address_type] ?? "fal fa-user"
		},
		/**
		 * Nome do participante, com o código quando existir
		 * @param item
		 * @returns {string}
		 */
		label(item) {
			const label = typeof item.label === "string" ? item.label : this.$localize(item.label)

			return item.code ? `${item.code} - ${label}` : label
		}
	}
}
</script>
